import React, { useRef, useEffect, useState } from "react";
import { withSidebar } from "../hoc/withSidebar";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../actions";
import CommonContainerBox from "../custom/containers/CommonContainerBox";
import ResponsiveDataGrid from "../custom/containers/ResponsiveDataGrid";
import CardList from "../custom/containers/cardList";
import ErrorMessage from "../custom/containers/ErrorMessage";
import { RoleType }  from "../../constants/sharedConstants.js";
import { transactionSearchHeading } from "../../constants/TransactionSearchConstants.js";
import { setFinancialInstitutionUIData } from "../../utils/helper";
import { ResponsiveBox, Typography } from "../primitives";


const RecallPendingApprovals = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {
        history,
        location: { state },
    } = props;

    const [errorMessage, setErrorMessage] = useState(null);
    const user = useSelector((state) => state.loginUserReducer.user);
    const [isBillerRole] = useState(user.role.role_type === RoleType.BILLER_ADMIN.type || user.role.role_type === RoleType.BILLER_USER.type);
    const currentFiNumber = useSelector((state) => state.fiReducer?.selectedFi || user?.fiNumber);

    const rpaResponse = useSelector(
        (state) => state.transactionEnquiryReducer
    );

    const [loading, setLoading] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [dataCount, setDataCount] = useState(0);

    const [transactionData, setTransactionData] = useState(  rpaResponse?.recallPendingApprovalsData?.data || null);
    const [searchValues, setSearchValues] = useState( state?.fromDetailPage && rpaResponse?.recallPendingApprovalsDetails || { offset: 0, limit: 100, currentFiNumber } );

    const fiReducer = useSelector( (state) => state.fiReducer );
    const [fiMap, setFiMap] = useState(null);

    const errorRef = useRef();
    useEffect(() => {
        if (errorRef.current)
            errorRef.current.focus();
    }, [errorMessage]);

    useEffect(() => {
        isBillerRole && setFinancialInstitutionUIData(fiReducer?.financialInstitutionList, setFiMap, null, null, user?.languageCode);
    }, [fiReducer.financialInstitutionList, user?.languageCode]);

    useEffect(() => {
        if (isBillerRole && !fiReducer?.financialInstitutionList?.length > 0)
            dispatch(actions.fiActions.getFinancialInstitutionList(t));
      
        let isLoadResults = true;
        if (state?.fromDetailPage && rpaResponse?.recallPendingApprovalsDetails) { // if coming back from the Details page, restore search values
            // restore pagination settings:  searchValues has already been updated from recallPendingApprovalsDetails during the initialization 
            setPageNumber(searchValues.offset / searchValues.limit);
            setDataCount(rpaResponse?.recallPendingApprovalsData?.count || 0);
            isLoadResults = state.isModified;  // we need to reload the results if the Trace object was modified
        }
        if (isBillerRole)
            searchValues.billerId = user.billerNonVolatileDto.biller_id;
        if (state?.fromDetailPage)
            state.fromDetailPage = null;  // resetting the coming-from-detail-page flag

        if (isLoadResults) {
            loadResults("from useEffect[]");
        }
    }, []);

    useEffect(() => {
        if (loading === false) {
            const responseData = rpaResponse?.recallPendingApprovalsData?.data;
            if (responseData?.length)
                responseData.forEach((r, idx) => r.seqNo = idx + 1 + searchValues.offset);

            setDataCount(rpaResponse.recallPendingApprovalsData?.count || 0);
            setTransactionData(responseData);
        }
    }, [loading]);

    const paginate = (values) => {
        searchValues.offset = values.startOffset;
        if (searchValues.limit !== (values.endOffset - values.startOffset))
            searchValues.limit = values.endOffset - values.startOffset;

        loadResults();
    };

    let loadResults = (tempText = "") => {
        if (errorMessage)
            setErrorMessage(null);
        setLoading(true);
        dispatch(
            actions.transactionEnquiryActions.searchRecallPendingApprovals(
                searchValues,
                { ...props, t, history, setLoading, setErrorMessage }
            )
        );
    };

    return (
        <div role="main">
            <ResponsiveBox sx={{ ml: 3 }}>
                <ErrorMessage 
                  error={errorMessage}
                  errorRef={errorRef}
                  mt={2}
                />

                <ResponsiveBox className="manageUsers__page__title">
                    {/* For Title update */}
                    <CommonContainerBox title={t("erps.recallpendingapprovals.page.title")} />
                    <Typography variant="h1">{t("erps.recallpendingapprovals.page.title")}</Typography>
                </ResponsiveBox>

                {transactionData !== null && transactionData !== undefined && Array.isArray(transactionData) && transactionData.length > 0 ? (
                        <>
                            <ResponsiveBox className="manageUsers_table_visible">
                                <ResponsiveDataGrid
                                    data={{
                                        rows: transactionData,
                                        columns: transactionSearchHeading("RPA", isBillerRole ? fiMap : null, "/recall-pending-approvals/recall-pending-approvals-detail"),
                                        count: dataCount,
                                    }}
                                    onAnyPaginationAction={paginate}
                                    sumOfColumnWidth="true"
                                    pageNumber={pageNumber}
                                    setPage={setPageNumber}
                                    rowPerPage={searchValues.limit}
                                    tableLabelText={"_Page Title_"}
                                    hideFooterPagination={false}
                                    pageName={"transaction-enquiry-rpa"}
                                />
                            </ResponsiveBox>
                            <ResponsiveBox className="manageUsers_card_visible">
                                <CardList
                                    data={{
                                        rows: transactionData,
                                        columns: transactionSearchHeading("RPA", isBillerRole ? fiMap : null, "/recall-pending-approvals/recall-pending-approvals-detail"),
                                        count: dataCount,
                                    }}
                                    hideFooterPagination={false}
                                    pageName={"recall-pending-approvals"}
                                    pageNumber={pageNumber}
                                    setPage={setPageNumber}
                                    rowPerPage={searchValues.limit}
                                />
                            </ResponsiveBox>
                        </>
                    )
                    : (
                        <ResponsiveBox mt={1}>
                            <Typography variant="body1">
                                { (transactionData?.length === 0)
                                    ? (`0 ${t("erps.transactionEnquiry.page.resultfound")}`)
                                    : (t("erps.availabledocuments.searchuser.notstarted", "Search not started"))
                                }
                            </Typography>
                        </ResponsiveBox>
                    )
                }
            </ResponsiveBox>
        </div>
    );
};

export default withSidebar(RecallPendingApprovals);

function ts() {  return new Date().toISOString().substring(11, 23);  }
